// File: assets/collection-sidebar-ajax.js
// Ruolo: Intercetta i click nella sidebar sottocategorie e attiva i filtri nativi (AJAX) di Horizon.
// In più: supporta URL puliti /collections/{handle}/{slug} e accesso diretto via redirect (?filter.p...) o via slug.
(function () {
  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(value);
    return String(value).replace(/["\\]/g, "\\$&");
  }

  function getCollectionHandleFromPath(pathname) {
    const parts = String(pathname).split("/").filter(Boolean);
    if (parts[0] !== "collections") return null;
    return parts[1] || null;
  }

  function getSlugFromPath(pathname) {
    const parts = String(pathname).split("/").filter(Boolean);
    return parts.length >= 3 ? parts[2] : null;
  }

  function makePrettyPath(handle, slug) {
    if (!handle) return window.location.pathname;
    return slug ? `/collections/${handle}/${slug}` : `/collections/${handle}`;
  }

  // --- Facets (manteniamo la tua logica) ---
  function findFacetInputByValue(value) {
    const escaped = cssEscape(value);
    const selector = `input[name="filter.p.m.custom.subcategory"][value="${escaped}"]`;
    return document.querySelector(selector);
  }

  function triggerNativeFacetChange(input) {
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function getGroupInputs() {
    return Array.from(document.querySelectorAll('input[name="filter.p.m.custom.subcategory"]'));
  }

  function clearFacetGroup() {
    const inputs = getGroupInputs();
    let changed = false;

    inputs.forEach((i) => {
      if (i.checked) {
        i.checked = false;
        changed = true;
      }
    });

    if (changed && inputs[0]) triggerNativeFacetChange(inputs[0]);
  }

  function setSingleValue(input) {
    const inputs = getGroupInputs();
    let changed = false;

    inputs.forEach((i) => {
      const shouldCheck = i === input;
      if (i.checked !== shouldCheck) {
        i.checked = shouldCheck;
        changed = true;
      }
    });

    if (changed) triggerNativeFacetChange(input);
  }

  // --- URL cleanup (solo cosmetico) ---
  // Dopo che Horizon aggiorna la pagina (AJAX), riscriviamo il path pulito.
  function syncPrettyUrlFromActive() {
    const handle = getCollectionHandleFromPath(window.location.pathname);
    if (!handle) return;

    const active = getGroupInputs().find((i) => i.checked);
    if (!active) {
      history.replaceState(history.state, "", makePrettyPath(handle, null));
      return;
    }

    // Trova lo slug dal link sidebar che ha il valore attivo
    const link = Array.from(document.querySelectorAll("a[data-csb-subcategory][data-csb-slug]")).find(
      (a) => a.dataset.csbSubcategory === active.value
    );

    if (!link || !link.dataset.csbSlug) return;

    history.replaceState(history.state, "", makePrettyPath(handle, link.dataset.csbSlug));
  }

  function schedulePrettySync() {
    // Horizon è async: proviamo più volte
    setTimeout(syncPrettyUrlFromActive, 150);
    setTimeout(syncPrettyUrlFromActive, 450);
    setTimeout(syncPrettyUrlFromActive, 900);
  }

  // --- Accesso diretto da redirect: ?filter.p... ---
  function getFilterValueFromQuery() {
    try {
      return new URL(window.location.href).searchParams.get("filter.p.m.custom.subcategory");
    } catch {
      return null;
    }
  }

  // Applica filtro leggendo query oppure slug; fa retry finché i facets esistono
  function applyValueWithRetry(value, retries = 30) {
    if (!value) return;

    const input = findFacetInputByValue(value);
    if (input) {
      // single select
      if (!input.checked) setSingleValue(input);
      schedulePrettySync();
      return;
    }

    if (retries <= 0) return;
    setTimeout(() => applyValueWithRetry(value, retries - 1), 150);
  }

  function applyFromSlugIfPresent() {
    const slug = getSlugFromPath(window.location.pathname);
    if (!slug) return false;

    const handle = getCollectionHandleFromPath(window.location.pathname);
    if (!handle) return false;

    // mappa slug -> valore via link sidebar (data-csb-slug)
    const link = document.querySelector(`a[data-csb-slug="${cssEscape(slug)}"][data-csb-subcategory]`);
    if (!link) return false;

    const value = link.dataset.csbSubcategory;
    if (!value) return false;

    // 1) FORZA prima l'URL con query del facet (così Horizon non interpreta lo slug come tag)
    try {
      const u = new URL(window.location.href);
      u.pathname = `/collections/${handle}`;
      u.searchParams.set("filter.p.m.custom.subcategory", value);
      history.replaceState(history.state, "", u.pathname + "?" + u.searchParams.toString());
    } catch {}

    // 2) applica facet (AJAX) e poi la maschera pulita verrà rimessa da schedulePrettySync()
    applyValueWithRetry(value);
    schedulePrettySync();
    return true;
  }

  // CLICK sidebar: manteniamo il tuo comportamento
  document.addEventListener("click", (e) => {
    const link = e.target.closest("a[data-csb-subcategory], a[data-csb-clear]");
    if (!link) return;

    // Intercetta solo quando il link resta nella stessa collezione (AJAX).
    try {
      const href = link.getAttribute("href");
      if (!href) return;
      const url = new URL(href, window.location.origin);

      // Se siamo su /collections/handle/slug, confrontiamo solo la base /collections/handle
      const currentHandle = getCollectionHandleFromPath(window.location.pathname);
      const targetHandle = getCollectionHandleFromPath(url.pathname);

      if (!currentHandle || !targetHandle || currentHandle !== targetHandle) return;
    } catch {
      return;
    }

    // CLEAR
    if (link.dataset.csbClear === "true") {
      e.preventDefault();
      clearFacetGroup();

      const handle = getCollectionHandleFromPath(window.location.pathname);
      if (handle) history.replaceState(history.state, "", makePrettyPath(handle, null));
      return;
    }

    const value = link.dataset.csbSubcategory;
    if (!value) return;

    const input = findFacetInputByValue(value);
    if (!input) return; // fallback: lascia navigazione normale

    e.preventDefault();

    // NON mascherare subito: prima deve partire l’AJAX del facet (evita matching tag/slug)
    // (manteniamo handle solo per coerenza/possibili estensioni future)
    getCollectionHandleFromPath(window.location.pathname);

    // PATCH: SINGLE-SELECT hard => prima resetta sempre, poi applica solo questo valore (no OR/AND)
    clearFacetGroup();
    setSingleValue(input);

    // Dopo l'update async del tema, forziamo replaceState sul path pulito
    schedulePrettySync();
  });

  // ON LOAD: gestisci redirect (?filter...) e URL pulito (/.../slug)
  document.addEventListener("DOMContentLoaded", () => {
    const qv = getFilterValueFromQuery();
    if (qv) {
      applyValueWithRetry(qv);
      // Non tocchiamo subito l’URL: Horizon deve usare la query; poi lo ripuliamo con schedulePrettySync()
      return;
    }

    applyFromSlugIfPresent();
  });

  // BACK/FORWARD: riapplica in base a slug (o pulisci)
  window.addEventListener("popstate", () => {
    const qv = getFilterValueFromQuery();
    if (qv) {
      applyValueWithRetry(qv);
      return;
    }

    const slugApplied = applyFromSlugIfPresent();
    if (!slugApplied) {
      // nessuno slug => URL base collezione => rimuovi filtro
      clearFacetGroup();
      schedulePrettySync();
    }
  });
})();
